import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import Layout from "./Layout";
import { LoaderProvider } from "./context/LoaderProvider.jsx";
import { NotificationProvider } from "./context/Notifications/NotificationContext.jsx";
import GlobalWebSocketListener from "./context/Notifications/GlobalWebSocketListener.jsx";


function App() {
  return (
    <LoaderProvider>
      <Router>
        <NotificationProvider>
          <GlobalWebSocketListener />
          <Layout />
        </NotificationProvider>
      </Router>
    </LoaderProvider>
  );
}

export default App;
